const openCartDrawerFallback = (trigger) => {
  const drawer = trigger.closest('cart-drawer-component');
  const dialog = drawer?.querySelector('dialog[ref="dialog"], dialog.cart-drawer__dialog');

  if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;

  dialog.showModal();
};

const closeCartDrawerFallback = (trigger) => {
  const dialog = trigger.closest('dialog.cart-drawer__dialog');

  if (!dialog || !dialog.open || typeof dialog.close !== 'function') return;

  dialog.close();
};

const syncMenuDrawerState = (details) => {
  if (!details) return;

  details.classList.toggle('menu-open', details.open);
  details.querySelector('summary')?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
};

document.addEventListener('click', (event) => {
  const cartTrigger = event.target.closest('[data-testid="cart-drawer-trigger"]');
  const cartClose = event.target.closest('.cart-drawer__close-button');
  const menuSummary = event.target.closest('.east-palm-mobile-menu summary.header__icon--menu');
  const menuClose = event.target.closest('.east-palm-mobile-menu .menu-drawer__close-button');

  if (cartTrigger) {
    window.setTimeout(() => openCartDrawerFallback(cartTrigger), 60);
  }

  if (cartClose) {
    window.setTimeout(() => closeCartDrawerFallback(cartClose), 0);
  }

  if (menuSummary) {
    const details = menuSummary.closest('details');
    window.setTimeout(() => syncMenuDrawerState(details), 0);
  }

  if (menuClose) {
    const details = menuClose.closest('details');

    if (details) {
      details.open = false;
      syncMenuDrawerState(details);
    }
  }
});

document.querySelectorAll('.east-palm-mobile-menu details').forEach(syncMenuDrawerState);
